import campaigns from 'Views/Campaigns/I18n/ptBR';

const ptBR = {
	home: {
		title: ' Portal empresas',
		dashboard: {
			title: 'Dashboard de salud',
			text: 'Consulta los datos generales de salud de los colaboradores',
		},
		employees: {
			title: 'Colaboradores',
			text: 'Consulta los datos generales de salud de los colaboradores',
		},
		candidates: {
			title: 'Candidatos',
			text: 'Gestión de exámenes de ingreso, compatibilidad del puesto',
		},
		nom035: {
			title: 'NOM-035',
			text: 'Mide los factores de riesgo y el entorno organizacional.',
		},
		hra: {
			title: 'Health Risk Assessment',
			text: 'Monitorea los programas de salud de tus colaboradores.',
		},
		users: {
			title: 'Gestión de usuarios',
			text: 'Consulta los datos generales de salud de los colaboradores',
		},
		jobProfiles: {
			title: 'Perfiles de puesto',
			text: 'Conoce los factores de riesgo de tus colaboradores',
		},
	},
	commons: {
		cancel: 'Cancelar',
		retryButton: 'Tentar de novo',
		moreInfo: 'Mais informações',
		xlsx: {
			buttonText: 'Gerar reporte',
			success:
				'Reporte gerado! Quando estiver pronto sera enviado ao seu email',
			error:
				'Houve um erro ao tentar gerar o reporte, deseja tentar novamente?',
		},
	},
	views: {
		campaigns,
	},
};

export default ptBR;
